export class DistributorCompanies {
  isgDistributorCompanyId: number | null;
  idgDistributorCompanyId: number | null;
}
